const SET_PUB_CARD_PAGES = 'storeCards/SET_PUB_CARD_PAGES';
const SET_CARD_PAGES = 'storeCards/SET_CARD_PAGES';
const SET_SELECTED = 'storeCards/SET_SELECTED';
const SET_CARDS = 'storeCards/SET_CARDS';
const ADD_CARDS = 'storeCards/ADD_CARDS';

export default {
  SET_PUB_CARD_PAGES,
  SET_CARD_PAGES,
  SET_SELECTED,
  SET_CARDS,
  ADD_CARDS,
};



// WEBPACK FOOTER //
// ./src/app/store-cards/store/mutation-types.js